import React from "react";
import { Toast, Button } from "antd-mobile";
import { post } from "../../utils/request";
import QRCode from "qrcode";
import { href } from "../../utils/util";

import api from "./api";

import "./index.less";
var timer = "";
class vehicleInquirySuccess extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      urlOps: {},
      detailData: {},
      qrImg: "",
      second: 3,
    };
  }

  componentDidMount() {
    var obj = "",
      obj1 = "",
      ops = {};
    if (window.location.hash.indexOf("?") > -1) {
      obj = window.location.hash.split("?")[1];
      obj1 = obj.split("&");
      for (var i = 0; i < obj1.length; i++) {
        ops[obj1[i].split("=")[0]] =
          obj1[i].split("=")[1] === "undefined" ? "" : obj1[i].split("=")[1];
      }
    }
    timer = setInterval(() => {
      if (this.state.second == 0) {
        clearInterval(timer);
        href(`/vehicleInquiry`);
      } else {
        this.setState((prevState) => ({ second: prevState.second - 1 }));
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(timer);
  }

  render() {
    const { urlOps, second } = this.state;
    // console.log(urlOps)
    return (
      <div className="vehicleInquirySuccessBox">
        <div className="successBox">
          <div>
            <div className="successIcon"></div>
            <div className="successTitle">询价申请已提交</div>
            <div className="successText">
              待询价完成后，我们将立即向您反馈。
            </div>
            <div className="successTime">
              <span style={{ color: "#009F90" }}>{second}s </span> 后将自动返回
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default vehicleInquirySuccess;



// WEBPACK FOOTER //
// ./src/vehicleInquiry/success/index.js